<template>
  <div v-if="sessions" id="data-list-list-view" class="data-list-container">
    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      max-items="100"
      search
      :data="sortedSessions"
      @selected="onClicked(selected.id)"
    >
      <template slot="thead">
        <vs-th sort-key="date">Date</vs-th>
        <vs-th sort-key="submittedAction">Submitted by</vs-th>
        <vs-th sort-key="status">Status</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <code>
                {{ formatDate(tr.date) }}
              </code>
            </vs-td>

            <vs-td>
              <code>
                {{ tr.submittedAction ? tr.submittedAction.userDisplayName : "N/A" }}
              </code>
            </vs-td>

            <vs-td>
              <vs-chip
                style="color: #111"
                :color="tr.status === 'SentMail' ? 'success' : tr.status === 'Submitted' ? 'warning' : 'danger'"
              >
                {{ statusLabel(tr.status) }}
              </vs-chip>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      selected: [],
      isMounted: false,
    };
  },
  computed: {
    ...mapGetters({
      sessions: "eodSessions/sessions",
      activeVenue: "venues/activeVenue",
    }),
    sortedSessions() {
      const filtered = (this.sessions || []).filter(
        (e) => e.status === "SentMail" || e.status === "Submitted"
      );
      filtered.sort((a, b) => (b.date > a.date ? 1 : -1));
      return filtered;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("LL");
    },
    statusLabel(status) {
      switch (status) {
        case "SentMail": return "Completed";
        case "Submitted": return "Processing";
        case "Draft": return "Draft";
        default: return status;
      }
    },
    onClicked(id) {
      this.$router.push({ name: "eodSession", params: { id } }).catch(() => {});
    },
  },
  async mounted() {
    this.isMounted = true;
    await this.$store.dispatch("eodSessions/getSessions", this.activeVenue.venueId);
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
